import React from "react";
import { Link } from "react-router-dom";
import Icon from "../icon";
import { LOCK } from "icons";

const CtaLink = ({ cta }) => (
  <Link
    to={cta.to}
    className="rounded text-sm font-medium text-primary underline underline-offset-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
  >
    {cta.label}
  </Link>
);

/**
 * Blurs a section and overlays a lock icon with a message (and optional CTA).
 * Pass `title` + `items` ([{ key, message, cta? }]) to list several issues,
 * each with its own CTA; otherwise `message` + `cta` render a single issue.
 * `children` must be placeholder content only: never pass real values, since
 * they would still be present in the DOM under the blur.
 */
export const EvtLockedSection = ({
  children,
  message,
  cta,
  title,
  items,
  icon = LOCK,
}) => (
  <div className="relative">
    <div
      aria-hidden="true"
      inert=""
      className="pointer-events-none select-none blur-sm"
    >
      {children}
    </div>
    <div className="absolute inset-0 flex items-center justify-center p-4">
      <div
        role="status"
        className="flex max-w-md flex-col items-center gap-2 text-center"
      >
        <span className="flex size-10 items-center justify-center rounded-full bg-muted">
          <Icon
            icon={icon}
            className="size-5 text-muted-foreground"
            aria-hidden="true"
          />
        </span>
        {items?.length ? (
          <>
            {title && (
              <p className="text-sm font-semibold text-foreground">{title}</p>
            )}
           <p className="text-sm font-medium text-foreground">{items[0].message}</p>
            {items[0].cta && <CtaLink cta={items[0].cta} />}
          </>
        ) : (
          <>
            <p className="text-sm font-medium text-foreground">{message}</p>
            {cta && <CtaLink cta={cta} />}
          </>
        )}
      </div>
    </div>
  </div>
);
